<div class="sale-list-item">
  <div class="sale-list-item__status-bar p-2 background-medium-00 flex items-center">
    <app-badge-status statusText="{{saleActions.title ?? '' | translate }}" [iconClass]="saleActions.iconBadgeClass ?? ''"></app-badge-status>
    @if (sale.status === 'APPROVED' && sale.rewardPoints === 0 && saleActions.subtitle) {
      <span class="sale-list-item__status-bar__message typography-body-m-regular">| {{ saleActions.subtitle | translate:{varDays: ACTIOS_CUT_OFF_DAYS } }}</span>
    } @else if (sale.status === 'APPROVED' && sale.rewardPoints !== 0) {

    } @else if (sale.status === 'DENIED') {
        @if (sale.denyReasonNew && sale.denyReasonNewLabel){
            <span class="sale-list-item__status-bar__message typography-body-m-regular">| {{ (sale.denyReasonNewLabel) | translate }}</span>
        }
    } @else if (saleActions.subtitle) {
      <span class="sale-list-item__status-bar__message typography-body-m-regular">| {{ saleActions.subtitle | translate:{varDays: ACTIOS_CUT_OFF_DAYS } }}</span>
    }
  </div>
  <div class="sale-list-item__card flex flex-col lg:flex-row BackgroundWhite">
    <div class="sale-list-item__card__info flex flex-col p-6 border-r">
      <p class="sale-list-item__card__info__item">
        <span class="sale-list-item__label typography-body-l-light">{{ 'my_sales.id_sale' | translate }}</span>&nbsp;<span class="sale-list-item__value typography-title-m primaryDefault-color">{{ sale.name }}</span>
      </p>
      <p class="sale-list-item__card__info__item flex">
        <span class="sale-list-item__label typography-body-l-light">{{ 'my_sales.client_name' | translate }}</span>&nbsp;
        <!-- <span *ngIf="sale.nameCustomer" class="sale-list-item__value typography-body-m-regular primaryDefault-color">{{ sale.nameCustomer }}</span> -->
        <span class="sale-list-item__value flex">
          <input type="text" class="sale-list-item__input typography-body-m-regular primaryDefault-color" placeholder="{{ 'ADD_CUSTOMER_NAME' | translate }}" [value]="sale.nameCustomer" (change)="updateCustomerName($event)" />
          <img src="assets/svgs/edit.svg" class="sale-list-item__value__edit-icon w-4 h-4 primaryDefault" />
        </span>
      </p>

      <div class="sale-list-item__divider w-full"></div>

      <p class="sale-list-item__card__info__item pb-2">
        <span class="sale-list-item__label typography-body-l-light">{{ 'my_sales.seller' | translate }}</span>&nbsp;<span class="sale-list-item__value typography-body-m-regular primaryDefault-color">{{ sale.contactName }}</span>
      </p>

      <div *ngIf="userInfo().accountType !== 'FABRICATOR'" class="sale-list-item__actios-block flex justify-between items-center px-[12px] h-[44px] background-light-00">
        <span class="typography-body-s-medium">{{ saleActions.pointsText | translate }}</span>
        <span class="typography-title-s">{{ sale.rewardPoints ?? '-' }}</span>
      </div>
    </div>
    <div class="sale-list-item__card__registration border-r">
      <div class="sale-list-item__card__registration__info">
        <div class="sale-list-item__card__registration__info__item pb-4">
          <span class="sale-list-item__label typography-body-l-light">{{ 'my_sales.registration_date' | translate }}</span><br />
          <span class="sale-list-item__value typography-body-m-regular primaryDefault-color">{{ sale.submissionDate | date }}</span>
        </div>
        <div class="sale-list-item__divider w-6"></div>
        <app-link *ngIf="sale.urlInvoice1" [isDocument]="true" [href]="sale.urlInvoice1" [size]="'medium'" [class]="sale.urlInvoice1 ? 'text-primary' : 'disabled'" [contentClass]="'text-primary flex gap-2'" gtmLabel="approved_file_view-invoice">{{ 'my_sales.view_invoice' | translate }}</app-link>
      </div>
      <div class="sale-list-item__card__registration__color">
        <div class="carousel" *ngIf="sale.saleItems && sale.saleItems.length > 0">
          <ngx-slick-carousel [config]="slideConfig">
            <div ngxSlickItem class="slide" *ngFor="let item of sale.saleItems">
              <div class="product-card flex flex-col items-center" style="gap: 4px">
                <p *ngIf="getItemApplicationLabel(item) && getItemApplicationLabel(item) !== '*None*'" class="typography-body-m-medium primaryDefault-color m-0">{{ getItemApplicationLabel(item) }}</p>
                <img
                  *ngIf="item?.product?.pictureURL"
                  src="{{ item.product.pictureURL }}?w=60&h=60&fit=crop"
                  [alt]="item.product.colorDesc"
                  class="w-[69px] h-[69px] rounded-full object-cover my-[12px]"
                />
                <app-cosentino-svg *ngIf="!item?.product?.pictureURL" [svgName]="'no-image'" [size]="72"></app-cosentino-svg>
                <p *ngIf="item?.product?.colorDesc" class="typography-title-s m-0 capitalize">{{ item.product.colorDesc?.toLowerCase() }}</p>
                <div *ngIf="item?.brand" class="sale-list-item__brand">
                  <img src="assets/icons/brands/{{item.brand?.toLowerCase()}}-black.svg" alt="{{item.brand}}">
                </div>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
        <div class="product-card flex flex-col items-center" *ngIf="!sale.saleItems || sale.saleItems.length === 0">
          <app-cosentino-svg [svgName]="'no-image'" [size]="72"></app-cosentino-svg>
        </div>
      </div>
  </div>
  <div class="sale-list-item__card__cta flex flex-col items-center p-6 gap-6" [ngClass]="{'justify-center': !saleActions.primaryButton && !saleActions.secondaryButton, 'justify-start': saleActions.primaryButton || saleActions.secondaryButton}">
    <p class="typography-title-s mt-0 mb-6 text-center">{{ saleActions.ctaText ?? '' | translate }}</p>
    <div *ngIf="saleActions.primaryButton || saleActions.secondaryButton" class="sale-list-item__card__cta-buttons flex-flex-col gap-4 w-full">
      <app-button *ngIf="saleActions.primaryButton" class="w-full mb-6" [primary]="sale.warrantyNumber === null" [secondary]="sale.warrantyNumber !== null" [size]="'medium'" (click)="handleClick(saleActions.primaryButton.actionOperation)" gtm-label="saleActions.primaryButton.actionOperation === 'completeSale' ? sale.status.toLowerCase() + '_button_complete-sale' : null">{{ saleActions.primaryButton.actionMessage ?? '' | translate }}</app-button>
      <app-button *ngIf="saleActions.secondaryButton" class="w-full" [ngClass]="{'py-2': sale.warrantyNumber !== null}" [primary]="true" [ghost]="true" [size]="'medium'" (click)="handleClick(saleActions.secondaryButton.actionOperation)" gtm-label="saleActions.secondaryButton.actionOperation === 'removeSale' ? sale.status.toLowerCase() + '_button_remove-sale' : null">{{ saleActions.secondaryButton.actionMessage | translate }}</app-button>
    </div>
  </div>
</div>
</div>

<app-confirm-modal
  [isOpen]="isConfirmModalVisible"
  title="{{ 'my_sales.remove_sale' | translate }}"
  message="{{ 'my_sales.confirmation_remove_sale' | translate }}"
  confirmText="{{ 'my_sales.remove' | translate }}"
  cancelText="{{ 'my_sales.keep' | translate }}"
  [buttonsInRow]="true"
  (onConfirm)="removeSale(sale.id)"
  (onCancel)="isConfirmModalVisible = false"
  (onClose)="isConfirmModalVisible = false"
/>
